import { QRCodeSVG } from 'qrcode.react'
import React, { useContext, useState } from 'react'
import { Container } from './style'
import { QRCodeContext } from '../../contexts/QRCodeContext'

const QRCodeModal = () => {
  const { contentJson } = useContext(QRCodeContext)
  
  return(
    <Container>
      <QRCodeSVG
        value={contentJson}
        fgColor='#0090d3'
        size={120}
        minVersion={1}






      />
    </Container>
  )
}

export default QRCodeModal